

var jingdian = [
    [117.218282, 39.091039, '天津博物馆'],
    [117.215557, 39.092418, '天津自然博物馆'],
    [117.801318, 39.110431, '国家海洋博物馆'],
    [117.224824, 39.093454, '天津科学技术馆'],
    [117.695076, 39.024225, '滨海新区科技馆'],
    [117.214838, 39.114422, '北疆博物院旧址'],
    [117.171614, 39.099928, '周恩来邓颖超纪念馆'],
    [117.153424, 39.175047, '平津战役纪念馆'],
    [117.220047, 39.091140, '天津美术馆'],
    [117.203326, 39.150495, '李叔同故居纪念馆'],
    [117.188295, 39.147010, '天津戏剧博物馆'],
    [117.245271, 39.116512, '元明清天妃宫遗址博物馆'],
    [117.189496, 39.159698, '三条石历史博物馆'],
    [117.199099, 39.148469, '天津民俗博物馆'],
    [117.217283, 39.133665, '天津邮政博物馆'],
    [117.215010, 39.136279, '天津金融博物馆'],
    [117.716507, 38.983803, '大沽口炮台遗址博物馆'],
    [117.693020, 39.022601, '滨海文化中心'],
    [117.820020, 39.161654, '泰达航母主题公园'],
    [117.668083, 39.014923, '极地海洋公园'],
    [117.824134, 39.039587, '东疆港亲海公园'],
    [117.748451, 39.151397, '天津野生动物园'],
    [117.171928, 39.088267, '天津动物园'],
    [117.710476, 39.029152, '天津K11购物艺术中心'],
    [117.258363, 39.030791, '天津节水科技馆'],
    [117.484481, 39.193572, '天津欢乐谷'],
    [117.746352, 39.163464, '天津方特水上乐园'],
    [117.193353, 39.160090, '天津之眼'],
    [117.200754, 39.123750, '西开教堂'],
    [117.188281, 39.098638, '天津广播电视塔'],
    [117.875908, 39.187489, '浪花艺术馆'],
    [117.839726, 39.170520, '力高阳光海岸'],
    [117.650583, 39.022227, '大梁子渡口'],
    [117.708924, 38.902074, '临港海岸线公园'],
    [117.844245, 39.098267, '东堤公园'],
    [117.833075, 39.083803, '观澜角公园'],
    [117.852550, 39.112942, '妈祖文化园'],
]

var restaurant = [
    // 天津
    [117.713229, 39.111951, '劳模海鲜'],
    [117.725249, 39.113646, '劳模海鲜'],
    [117.710422, 39.111916, '老北塘海鲜'],
    [117.668465, 39.041338, '聚味斋香辣蟹'],
    [117.672229, 39.045678, '独一处火锅鸡'],
    [117.675998, 39.022854, '独一处火锅鸡'],
    [117.636004, 39.043622, '满满鱼馆'],
    [117.661795, 39.023850, '恩来顺火锅'],
    [117.732202, 39.029384, '沽上民肴'],
    [117.657076, 39.051493, '沽上民肴'],
    [117.671303, 39.047480, '听潮海鲜'],
    [117.701294, 39.040643, '听潮海鲜'],
    [117.664522, 39.041536, '北塘刘家海鲜'],
    [117.663505, 39.046156, '北塘刘家海鲜'],
    [117.676597, 39.022928, '红旗饭庄'],
    [117.612335, 39.026850, '泉鑫牛肉馆'],
    [117.650610, 39.047650, '湘江里早市'],
    [117.660728, 39.043004, '苏州里早市'],
    [117.661570, 39.048902, '文明里早市'],
    [117.714968, 39.047150, '回德斋早点铺'],
    [117.694119, 39.032817, '乐乐居酒屋'],
    [117.716885, 39.031275, '山上下日料'],
    [117.707095, 39.038483, '白茅陈潮汕菜'],
    [117.686362, 39.022402, '丁记肠粉'],
    [117.651311, 39.064464, '小满皮皮虾锅贴'],
    [117.751713, 39.126517, '小满皮皮虾锅贴'],
    [117.666739, 39.048449, '小满皮皮虾锅贴'],
    [117.654521, 39.025951, '大鸿顺锅贴饺子楼'],
    [117.658495, 39.051126, '大鸿顺锅贴饺子楼'],
    [117.655163, 39.026449, '顾记三合顺'],
    [117.673110, 39.029574, '大厨炒菜'],
    [117.665895, 39.040160, '满堂大饼牛肉'],

]


var tianjin = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    },
    {
        name: '餐馆',
        group: 'base',
        list: restaurant,
        show: false,
        color: 'green'
    }
]


export default tianjin